{
  "tabs": {
    "home": "होम",
    "inventory": "सामान",
    "meals": "भोजन",
    "cook": "खाना",
    "shopping": "खरीदारी"
  },
  "greeting": {
    "morning": "सुप्रभात",
    "afternoon": "नमस्कार",
    "evening": "शुभ संध्या",
    "there": "जी"
  },
  "home": {
    "quickActions": "जल्दी काम",
    "mealOfDay": "आज का भोजन",
    "expiringSoon": "जल्दी खत्म होगा",
    "tapToReorder": "दोबारा ऑर्डर के लिए टैप करें",
    "expiredBanner": "इन्वेंटरी से {{count}} चीज़ हटाई गई (एक्सपायर)",
    "expiredBanner_other": "इन्वेंटरी से {{count}} चीज़ें हटाई गईं (एक्सपायर)",
    "emptyPantryTitle": "आपकी रसोई खाली है",
    "emptyPantrySub": "बिल स्कैन करें या भोजन आइडिया के लिए सामान जोड़ें",
    "freshPantryTitle": "रसोई बढ़िया लग रही है",
    "freshPantrySub": "{{count}} चीज़ें ट्रैक हो रही हैं — कुछ भी जल्दी खत्म नहीं होगा",
    "freshPantrySub_one": "1 चीज़ ट्रैक हो रही है — कुछ भी जल्दी खत्म नहीं होगा",
    "freshPantryBadge": "सब ठीक",
    "today": "आज",
    "days": "{{count}} दिन",
    "oneDay": "1 दिन"
  },
  "quickActions": {
    "aiBuddy": "AI साथी",
    "addItem": "सामान जोड़ें",
    "mealIdea": "भोजन आइडिया",
    "logMeal": "भोजन लॉग",
    "addToList": "लिस्ट में जोड़ें"
  },
  "inventory": {
    "title": "सामान",
    "subtitle": "आपकी रसोई, पूरी तरह ट्रैक",
    "subtitleLoading": "रसोई लोड हो रही है…",
    "searchPlaceholder": "सामान खोजें…",
    "addItem": "सामान जोड़ें",
    "addManually": "खुद जोड़ें"
  },
  "shopping": {
    "title": "खरीदारी लिस्ट",
    "subtitle": "मील प्लान के हिसाब से सामान",
    "searchPlaceholder": "लिस्ट खोजें…",
    "addItem": "सामान जोड़ें"
  },
  "meals": {
    "planningTitle": "मील प्लानिंग",
    "planningSubtitle": "आपकी रसोई के हिसाब से भोजन",
    "dietTitle": "डाइट",
    "dietSubtitle": "AI इनसाइट्स और रात की डाइजेस्ट"
  },
  "cook": {
    "title": "खाना",
    "subtitleMessage": "अपने रसोइये को मैसेज",
    "subtitleRecipe": "स्टेप-बाय-स्टेप रेसिपी",
    "cookingMode": "रेसिपी",
    "cookMode": "रसोइये को मैसेज",
    "cookingLabel": "खाना बनाना"
  },
  "profile": {
    "settings": "सेटिंग्स",
    "preferences": "पसंद",
    "appLanguage": "ऐप भाषा",
    "appLanguageHint": "ऐप के मेन्यू और लेबल की भाषा",
    "languageEn": "English",
    "languageHi": "हिन्दी",
    "languageKn": "ಕನ್ನಡ",
    "help": "मदद",
    "takeTour": "टूर लें",
    "takeTourSub": "होम, सामान, भोजन, खाना और खरीदारी का वॉकथ्रू",
    "marketingPush": "सूचनाएँ",
    "marketingPushHint": "टिप्स, नई सुविधाएँ और अपडेट (केवल ऐप पर)।",
    "marketingPushToggle": "उत्पाद समाचार और अपडेट",
    "marketingPushLoadError": "सूचना सेटिंग लोड नहीं हो सकी।",
    "marketingPushSaveError": "सूचना सेटिंग अपडेट नहीं हो सकी।",
    "signOut": "साइन आउट",
    "memories": "यादें"
  },
  "common": {
    "save": "सेव",
    "cancel": "रद्द",
    "loading": "लोड हो रहा है…"
  }
}
